import { useEffect } from "react";
import { Button, Grid, TextField } from "src/components";
import Avatar from "src/components/Avatar";
import BaseComponent from "src/core/base.component";
import { useCaptchaImageQuery } from "src/services/Auth/AuthApi";
import { useAppDispatch, useAppSelector } from "src/store";
import RefreshIcon from '@mui/icons-material/Refresh';
import AuthSlice from "src/store/slices/Auth/AuthSlice";
const LbysCptch = (): JSX.Element => {
    const userState = useAppSelector(s => s.userLogin)
    const dispatch = useAppDispatch();
    const query = useCaptchaImageQuery(null, { skip: userState.hataSayi < 2 });
    useEffect(() => {
        query.refetch();
    }, [userState.hataSayi])
    return (
        <BaseComponent>
            <Grid container justifyContent={"center"}>
                <Grid item  xs={12} sm={12} md={6} lg={7} xl={8}>
                    <Avatar
                        src={ query.data?.captchaImage ? "data:image/png;base64," + query.data.captchaImage : ""}
                        variant="rounded"
                        sx={{
                            width: "100%",
                            height: "100%"
                        }}
                    >
                    </Avatar>
                </Grid>
                <Grid item xs={12} sm={12} md={4} lg={3} xl={2}>
                    <Button
                        variant="outlined"
                        size="medium"
                        loading={query.isFetching}
                        startIcon={<RefreshIcon/>}
                        onClick={(e)=>query.refetch()}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        label="Resimdeki değerleri giriniz"
                        value={userState.captchaKodu}
                        error={Boolean(userState.captchaHelpertext)}
                        helperText={userState.captchaHelpertext}
                        onChange={(e)=>{
                            dispatch(AuthSlice.actions.setState({
                                ...userState,
                                captchaKodu: e.target.value,
                                captchaHelpertext: "",
                                captchaId: query.data?.captchaId ?? null
                            }))
                        }}
                    />
                </Grid>
            </Grid>
        </BaseComponent>
    )
}
export default LbysCptch;